"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.VerticalStack = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
require("./VerticalStack.css");
var _VerticalStackComponent = require("./components/VerticalStackComponent.js");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["children", "className", "spacing", "width", "height", "bg", "borderRadius", "justifyContent", "alignItems", "disabled", "disablebgColor"];
const VerticalStack = props => {
  const {
      children,
      className,
      spacing = '0px',
      width = '100%',
      height = '100%',
      bg = 'none',
      borderRadius = '0px',
      justifyContent = 'flex-start',
      alignItems = 'flex-start',
      disabled,
      disablebgColor
    } = props,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  const verticalStack = [`vertical-stack`, className].join(' ');
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_VerticalStackComponent.VerticalStackComponent, Object.assign({
    spacing: spacing,
    width: width,
    height: height,
    bg: bg,
    justifyContent: justifyContent,
    borderRadius: borderRadius,
    alignItems: alignItems,
    className: verticalStack,
    disabled: disabled,
    disablebgColor: disablebgColor
  }, rest, {
    children: children
  }));
};
exports.VerticalStack = VerticalStack;
var _default = exports.default = VerticalStack;